module.exports = __webpack_public_path__ + "static/media/tti_why_talentx.18b970c1.png";